export enum SubmitStatus {
  Failed = 'failed',
  Processing = 'processing',
  Sent = 'sent',
  Success = 'success',
}
